<div class="intersection">
  <div class="instructions">
    Search for an intersection by typing the names of two intersecting streets separated by <em>and</em>.
    Example: <i>North and Front</i>
  </div>
  <div class="input-container">
      <input id="intersectionSearchText" (click)="clearSelectedResult()"
             placeholder="Search for an intersection Example: North and Front"
             (ngModelChange)="searchUpdated.next(searchText)" [(ngModel)]="searchText" type="text">

      <label style="margin: 3px 0;">
          County (Optional)
          <select class="select" [(ngModel)]="county" name="county" id="county">
              <option> </option>
              <option *ngFor="let county of counties" [ngValue]="county">{{ county.name }} ({{ county.countyCode }})</option>
          </select>
      </label>
  </div>
  <div class="loading" *ngIf="loading">
    Loading...
  </div>
  <div class="results" *ngIf="!loading && !selectedResult && results && results.length">
    <div *ngFor="let result of results; let i = index" (click)="selectResult(result)" class="result" [title]="'Node: ' + result.nodeId">
        <div class="primary-text">{{ result.displayName }}</div>
      <div class="secondary-text">County: {{ result.county }}</div>
      <div class="tertiary-text">Route: {{ result.stateRoute }}</div>
    </div>
  </div>
  <div class="selected-result" *ngIf="selectedResult && searchText.length" (click)="clearSelectedResult()" [title]="'Node: ' + selectedResult.nodeId">
    <div class="result">
      <div class="primary-text">{{ selectedResult.displayName }}</div>
      <div class="secondary-text">County: {{ selectedResult.county }}</div>
      <div class="tertiary-text">Route: {{ selectedResult.stateRoute }}</div>
    </div>
  </div>
  <div class="no-results" *ngIf="searchComplete && !loading && results && results.length === 0">
    <span>No results found.</span>
  </div>
</div>
